module.exports = __webpack_public_path__ + "img/img4.b1e6f619.png";